import React from "react";
import Breadcrumb from "../../components/Breadcrumb";
import EducationSection from "./EducationSection";

const EducationMain = ({
  degrees,
  educationsData,
  isFetching,
  currentPage,
  selectedDegree,
  onPageChange,
  onDegreeFilter,
  educationalProgramsRef,
}) => {
  return (
    <main>
      <Breadcrumb title="Education" />
      <EducationSection
        educationsData={educationsData}
        degrees={degrees}
        isFetching={isFetching}
        currentPage={currentPage}
        selectedDegree={selectedDegree}
        onPageChange={onPageChange}
        onDegreeFilter={onDegreeFilter}
        educationalProgramsRef={educationalProgramsRef}
      />
    </main>
  );
};

export default EducationMain;
